<script setup>
import { onMounted } from 'vue';
import { useSubscription } from '../../composables/useSubscription';

const { plan, usage, isFreeTier, refreshUsage, usagePercentage, usageText } = useSubscription();

const displayResources = [
  { key: 'events_created', label: 'Events' },
  { key: 'emails_sent', label: 'Emails' },
  { key: 'campaigns', label: 'Campaigns' },
];

function getBarColor(percent) {
  if (percent >= 90) return 'bg-red-400';
  if (percent >= 75) return 'bg-amber-400';
  return 'bg-cyan-400';
}

onMounted(() => {
  refreshUsage();
});
</script>

<template>
  <div class="px-2 py-3">
    <div class="text-[10px] uppercase tracking-wider text-gray-500 font-semibold mb-2 px-1">
      {{ plan.name }} Plan
    </div>
    <div class="space-y-2">
      <div
        v-for="res in displayResources"
        :key="res.key"
        class="px-1"
      >
        <div class="flex items-center justify-between mb-0.5">
          <span class="text-[11px] text-gray-400">{{ res.label }}</span>
          <span class="text-[10px] text-gray-500">{{ usageText(res.key) }}</span>
        </div>
        <div class="h-1 bg-gray-700 rounded-full overflow-hidden">
          <div
            :class="['h-full rounded-full transition-all duration-500', getBarColor(usagePercentage(res.key))]"
            :style="{ width: Math.min(100, usagePercentage(res.key)) + '%' }"
          ></div>
        </div>
      </div>
    </div>
    <a
      v-if="isFreeTier"
      href="/upgrade"
      class="block mt-3 mx-1 text-center text-[11px] font-semibold text-cyan-400 hover:text-cyan-300 transition-colors"
    >
      Upgrade Plan
    </a>
    <a
      v-else
      href="/billing"
      class="block mt-3 mx-1 text-center text-[11px] text-gray-500 hover:text-gray-300 transition-colors"
    >
      Manage Billing
    </a>
  </div>
</template>
